import CreateEventFormTab from "./CreateEventFormTab"
import BasicInfoForm from "./BasicInfoForm";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
const BasicInfo = () => {

    return <div className="eventCreationFrom">
        <CreateEventFormTab Id="basic" />
        <BasicInfoForm />
    </div>
}
export default BasicInfo